import { __extends } from "tslib";
import React from 'react';
import styles from './HeaderDetails.scss';
import classNames from 'classnames';
import { AvatarType, isImageAvatar, isNoneAvatar, isSvgAvatar, } from '../../../../constants/avatar-type';
import { translate } from 'react-i18next';
import { AvailabilityStatus } from '../../../..';
import { responseTime } from '@wix/inbox-common';
import Lightning from './../../../../svgIcons/dist/components/Lightning';
var HeaderDetails = /** @class */ (function (_super) {
    __extends(HeaderDetails, _super);
    function HeaderDetails(props) {
        var _this = _super.call(this, props) || this;
        _this.onlineMessage = null;
        _this.isAvailable = function () {
            return _this.props.availabilityStatus === AvailabilityStatus.Available;
        };
        _this.availabilityClass = function () {
            return _this.isAvailable() ? styles.availabilityAvailable : styles.availabilityAway;
        };
        _this.hasAvatar = function () { return !isNoneAvatar(_this.props.avatar); };
        _this.headerAvatar = function () {
            var _a;
            var isHeaderFolded = _this.props.isHeaderFolded;
            return (React.createElement("div", { className: classNames(styles.avatar, (_a = {},
                    _a[styles.empty] = !_this.hasAvatar(),
                    _a)), "data-hook": "header-avatar" },
                _this.avatar(),
                _this.withAvailabilityIndication() &&
                    isHeaderFolded &&
                    _this.hasAvatar() &&
                    _this.availabilityPimple()));
        };
        _this.availabilityPimple = function () {
            var backgroundColor = _this.props.backgroundColor;
            return (React.createElement("span", { "data-hook": "availability-indication-pimple", className: classNames(styles.availabilityPimple, _this.availabilityClass()), style: { borderColor: backgroundColor } }));
        };
        _this.onProfileClick = function (e) {
            var _a = _this.props, onProfileClick = _a.onProfileClick, isHeaderFolded = _a.isHeaderFolded;
            if (onProfileClick && !isHeaderFolded) {
                e.stopPropagation();
                onProfileClick();
            }
        };
        _this.avatar = function () {
            var avatar = _this.props.avatar;
            if (isImageAvatar(avatar)) {
                return (React.createElement("img", { "data-hook": "header-custom-image", className: styles.headerCustomImage, onClick: _this.onProfileClick, alt: "header custom image", src: avatar.imgUrl }));
            }
            if (isSvgAvatar(avatar)) {
                return (React.createElement("div", { "data-hook": "header-default-image", onClick: _this.onProfileClick, className: styles.headerCustomImage }, avatar.svg));
            }
            return React.createElement("span", { "data-hook": "header-no-avatar", className: styles.noAvatar });
        };
        _this.headerTitle = function () {
            var onlineTitle = _this.props.onlineTitle;
            return (React.createElement("h2", { "data-hook": "header-title", id: "header-title", onClick: _this.onProfileClick, className: styles.headerTitle }, onlineTitle));
        };
        _this.headerSubtitle = function () {
            var _a;
            var _b = _this.props, isHeaderFolded = _b.isHeaderFolded, t = _b.t;
            var withPimple = !isHeaderFolded || !_this.hasAvatar();
            var availabilityText = _this.isAvailable()
                ? t('header.availability.available')
                : t('header.availability.away');
            return (React.createElement("div", { className: styles.headerSubtitle, "data-hook": "header-subtitle" },
                withPimple && _this.availabilityPimple(),
                React.createElement("span", { "data-hook": "availability-indication-header", className: classNames(styles.availabilityText, (_a = {},
                        _a[styles.withPimple] = withPimple,
                        _a)) }, availabilityText)));
        };
        _this.typicallyReplies = function () {
            var _a = _this.props, typicallyReplies = _a.typicallyReplies, availabilityStatus = _a.availabilityStatus;
            if (availabilityStatus === AvailabilityStatus.Available &&
                typicallyReplies &&
                typicallyReplies.isEnabled) {
                var period = (typicallyReplies && typicallyReplies.period) ||
                    responseTime.RESPONSE_TIME.ASAP;
                var text = responseTime.getValueFor(period);
                return (React.createElement("span", { className: styles.typicallyRepliesText, "data-hook": "typically-replies" },
                    React.createElement(Lightning, { className: styles.lightningIcon }),
                    text));
            }
        };
        _this.typicallyRepliesTitle = function () {
            var isHeaderFolded = _this.props.isHeaderFolded;
            var typicallyRepliesComponent = _this.typicallyReplies();
            if (isHeaderFolded && typicallyRepliesComponent) {
                return (React.createElement("div", { className: styles.headerSubtitle, "data-hook": "header-subtitle" }, typicallyRepliesComponent));
            }
        };
        _this.headerMessage = function () {
            var onlineMessage = _this.props.onlineMessage;
            return (React.createElement("span", { "data-hook": "header-message", className: styles.headerMessage, ref: function (ref) { return (_this.onlineMessage = ref); }, onMouseOver: _this.handleOverflowTooltip, title: _this.state.onlineMessageOverflow ? onlineMessage : '' }, onlineMessage));
        };
        _this.handleOverflowTooltip = function () {
            return _this.setState({ onlineMessageOverflow: _this.isOverFlow() });
        };
        _this.isOverFlow = function () {
            return !!_this.onlineMessage &&
                _this.onlineMessage.clientHeight < _this.onlineMessage.scrollHeight;
        };
        _this.withAvailabilityIndication = function () {
            return _this.props.availabilityStatus === AvailabilityStatus.Away;
        };
        _this.headerDetailsClasses = function () {
            var _a;
            var _b = _this.props, isHeaderFolded = _b.isHeaderFolded, shouldApplyUnfoldAnimation = _b.shouldApplyUnfoldAnimation, shouldApplyFoldAnimation = _b.shouldApplyFoldAnimation, shouldApplyExpandAnimation = _b.shouldApplyExpandAnimation, hasBackButton = _b.hasBackButton, clickable = _b.clickable, isExpanded = _b.isExpanded;
            return classNames((_a = {},
                _a[styles.headerDetails] = true,
                _a[styles.folded] = isHeaderFolded,
                _a[styles.unfolded] = !isHeaderFolded,
                _a[styles.withAvailability] = _this.withAvailabilityIndication(),
                _a[styles.shouldApplyFoldAnimation] = shouldApplyFoldAnimation,
                _a[styles.shouldApplyUnfoldAnimation] = shouldApplyUnfoldAnimation,
                _a[styles.shouldApplyExpandAnimation] = shouldApplyExpandAnimation,
                _a[styles.hasBackButton] = hasBackButton && isExpanded,
                _a[styles.clickable] = clickable,
                _a));
        };
        _this.state = {
            onlineMessageOverflow: false,
        };
        return _this;
    }
    HeaderDetails.prototype.render = function () {
        var _a = this.props, toggleHeaderFolded = _a.toggleHeaderFolded, isExpanded = _a.isExpanded, isHeaderFolded = _a.isHeaderFolded;
        return (React.createElement("div", { "data-hook": "header-details", className: this.headerDetailsClasses(), onClick: function () { return isExpanded && toggleHeaderFolded(); } },
            this.headerAvatar(),
            React.createElement("div", { className: styles.titling },
                this.headerTitle(),
                this.withAvailabilityIndication()
                    ? this.headerSubtitle()
                    : this.typicallyRepliesTitle()),
            !isHeaderFolded && (React.createElement(React.Fragment, null,
                this.headerMessage(),
                React.createElement("div", { className: styles.typicallyRepliesMessage }, this.typicallyReplies())))));
    };
    HeaderDetails.defaultProps = {
        avatar: { avatarType: AvatarType.None },
        hasBackButton: false,
    };
    return HeaderDetails;
}(React.Component));
// This fixes type-errors for consuming projects.
// This is an ugly type hack because our version
// of @types/react-i18next is fairly outdated
// They're using their own custom Omit<...> type
// for back in the day TypeScript didn't come
// with it.
// Since updating @types/react-i18next is
// a surprisingly difficult task, we're forced
// to do this for now.
export default translate()(HeaderDetails);
//# sourceMappingURL=HeaderDetails.js.map